var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('theHeader'),_c('div',{staticClass:"main"},[_c('router-view')],1),_c('TheFotter',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]})],1)}
var staticRenderFns = []

export { render, staticRenderFns }